// extracted by mini-css-extract-plugin
export default {"tableRow":"task_tableRow__DD9xQ","tableCell":"task_tableCell__Scpua","grayRow":"task_grayRow__IUsGE"};